import type { ArenaFilters, ArenaSample } from "./data/types";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

type Props = {
  samples: ArenaSample[];
  disabled?: boolean;
  filters: ArenaFilters;
  onChange: (filters: ArenaFilters) => void;
};

function unique<T>(values: T[]): T[] {
  return [...new Set(values)];
}

export function ArenaFilters({ samples, filters, onChange, disabled }: Props) {
  const languages = unique(samples.map((s) => s.language));
  const categories = unique(samples.map((s) => s.category));

  return (
    <div className="flex flex-wrap gap-3 items-end">
      <div className="flex flex-col gap-1.5">
        <Label className="text-xs text-muted-foreground">Language</Label>
        <Select disabled={disabled} value={filters.language} onValueChange={(v) => onChange({ ...filters, language: v as ArenaFilters["language"] })}>
          <SelectTrigger className="h-8 w-36 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All languages</SelectItem>
            {languages.map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label className="text-xs text-muted-foreground">Category</Label>
        <Select disabled={disabled} value={filters.category} onValueChange={(v) => onChange({ ...filters, category: v })}>
          <SelectTrigger className="h-8 w-36 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All categories</SelectItem>
            {categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
